import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/Button';
import { ModuleId } from '../../content';
import { GroupId } from '../../config/systemConfig';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
import { DjayAvatar } from '../../mascot';
interface ValidationErrorModalProps {
  error: {
    moduleId: ModuleId;
    message: string;
    hasContent: boolean;
  };
  selectedGroup: GroupId;
  onClose: () => void;
  onSwitchToGroup6: () => void;
  onNavigateToModules: () => void;
}
export function ValidationErrorModal({
  error,
  selectedGroup,
  onClose,
  onSwitchToGroup6,
  onNavigateToModules
}: ValidationErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onClose);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-2396" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-2397">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="validation-error-title" className="bg-white rounded-3xl shadow-2xl shadow-indigo-100 max-w-md w-full p-8 border-2 border-slate-100 relative overflow-hidden" data-id="element-2398">
          {/* Decorative background blur */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-indigo-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2399" />

          <div className="text-center relative z-10" data-id="element-2400">
            {/* Djay Avatar */}
            <div className="flex justify-center mb-4" data-id="element-2401">
              <DjayAvatar size="lg" emotion="thinking" animate data-id="element-2402" />
            </div>

            <h2 id="validation-error-title" className="text-2xl font-black text-slate-900 mb-2 tracking-tight" data-id="element-2403">
              Hmm, even geduld!
            </h2>
            <p className="text-slate-600 font-medium mb-6 leading-relaxed" data-id="element-2404">
              Voor dit onderwerp zijn er nog geen oefenvragen beschikbaar in
              groep {selectedGroup}. Probeer een ander onderwerp!
            </p>

            <div className="flex flex-col gap-3" data-id="element-2405">
              <Button onClick={onClose} variant="primary" size="xl" fullWidth className="shadow-lg shadow-indigo-200/50 rounded-2xl" data-id="element-2406">
                <ArrowLeft className="w-5 h-5 mr-2" data-id="element-2407" />
                Terug
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}